package org.maplibre.compose.map

/** The browser runs everything on one thread. */
internal actual fun currentThreadIdentity(): Any = Unit
